import React from "react";

import dayjs from "dayjs";

import { getGridSingleSelectOperators } from "@mui/x-data-grid";

import {
  Select,
  MenuItem,
  TextField,
  Box,
  Button,
  Tooltip,
  IconButton,
  Chip,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

import MessageIcon from "@mui/icons-material/Message";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import CustomerEditInput from "../components/editors/CustomerEditInput";
import CarrierEditInput from "../components/editors/CarrierEditInput";
import ClaimEditInput from "../components/editors/ClaimEditInput";
import CreditEditInput from "../components/editors/CreditEditInput";
import ListEditInput from "../components/editors/ListEditInput";
import AddIcon from "@mui/icons-material/Add";
import { getColorFromName } from "./ownerColors";
import Api from "../Api/Api";
import { toast } from "sonner";
export const buildColumns = ({
  cols,
  opts,
  ownerList,
  carrierList,
  claimList,
  creditList,
  openImportDialog,
  selectionModel,
  setRows,
  setColumnDialog,
  listSuggestions,
  openCommentDrawer,
  isSuperAdmin,
  columnRestrictions,
  openPermissionDialog,
}) => {
  return cols.map((colObj, index) => {
    console.log(colObj);
    const col = colObj.field;
    const colType = (colObj.ui_type || colObj.type || "").toLowerCase();
    const listType = colObj.list_type;
    const colOptions = opts[col] || [];
    const isSystemField = ["creation_log", "last_update"].includes(col);

    const isSelectField =
      (colOptions.length > 0 && colType !== "list") || col === "owner_id";

    const isListField =
      colType === "list" || colType === "dropdown" || colType === "select";

    const isDateField =
      !isSystemField &&
      (colType?.includes("date") || colType?.includes("timestamp"));

    const isCurrencyField =
      colType?.includes("decimal") ||
      colType?.includes("float") ||
      colType?.includes("double");
    const isCustomerField = col === "customer_name";

    const baseCol = {
      field: col,
      headerName: col,
      flex: 1,
      minWidth: 250,
      editable: col !== "owner_id" && col !== "owner_name",
      type: isSelectField ? "singleSelect" : "string",

      valueOptions:
        col === "owner_id"
          ? ownerList
          : isSelectField
            ? colOptions.map((o) => o.label)
            : undefined,
    };

    // let pinnedWidth = 200;

    // if (index === 0) {
    //   pinnedWidth = 180;
    // }

    // if (index === 1) {
    //   pinnedWidth = 220;
    // }

    // =========================
    // ✅ CUSTOMER AUTOCOMPLETE
    // =========================
    // if (col === "customer_name") {
    //   return {
    //     ...baseCol,
    //     filterable: true,
    //     sortable: true,
    //     align: "center",
    //     headerAlign: "center",
    //     renderEditCell: (params) => <CustomerEditInput {...params} />,

    //     getQuickFilterText: (params) => {
    //       if (!params || !params.row) return "";
    //       return params.value ? String(params.value).toLowerCase() : "";
    //     },
    //   };
    // }

    // =========================
    // ✅ DEFAULT COLUMN
    // =========================
    const isLastColumn = index === cols.length - 1;

    return {
      field: col,
      headerName: col.replaceAll("_", " "),

      flex: 1,
      minWidth: 180,
      align: "center",
      display: "flex",
      headerAlign: "center",
      filterable: true,

      // ✅ EDIT CONTROL
      editable: col !== "owner_id" && col !== "owner_name" && !isSystemField,

      // ✅ TYPE (ONLY ONCE!)
      type: isDateField
        ? "date"
        : isCurrencyField
          ? "number"
          : isSelectField
            ? "singleSelect"
            : "string",

      // ✅ SELECT OPTIONS
      valueOptions: isSelectField ? colOptions.map((o) => o.label) : undefined,

      filterOperators: isSelectField
        ? getGridSingleSelectOperators()
        : undefined,

      // renderCell: (params) => {
      //   if (isDateField) {
      //     if (!params.value) return "";
      //     return dayjs(params.value).format("YYYY-MM-DD");
      //   }

      //   return params.value;
      // },

      valueFormatter: (params) => {
        if (!params?.value) return "";

        // 💰 currency
        if (isCurrencyField) {
          return `$${params.value}`;
        }

        // keep your existing date logic untouched
        if (isDateField) {
          return dayjs(params.value).format("YYYY-MM-DD");
        }

        return params.value;
      },

      renderEditCell: (params) => {
        const { id, field, value, api } = params;

        if (isCustomerField) {
          return <CustomerEditInput {...params} />;
        }

        if (field === "carrier") {
          return (
            <CarrierEditInput {...params} carrierList={[...carrierList]} />
          );
        }

        if (field === "reason_for_claim") {
          return <ClaimEditInput {...params} claimList={[...claimList]} />;
        }

        if (field === "credit_type") {
          return <CreditEditInput {...params} creditList={[...creditList]} />;
        }

        if (isListField) {
          return (
            <ListEditInput
              {...params}
              listSuggestions={listSuggestions?.[listType] || []}
            />
          );
        }

        if (isSelectField) {
          return (
            <Select
              autoFocus
              value={value || ""}
              onChange={async (e) => {
                const newValue = e.target.value;
                const field = params.field;
                const rowId = params.id;

                // get selected rows safely
                const selectedIds =
                  api.getSelectedRows?.() instanceof Map
                    ? Array.from(api.getSelectedRows().keys())
                    : [];

                const hasBulk = selectedIds.length > 0;

                try {
                  // ======================
                  // 🔥 BULK UPDATE
                  // ======================
                  if (hasBulk) {
                    const ids = selectedIds;

                    await Api.post("/dashboard/bulk-status-update", {
                      ids,
                      field,
                      value: newValue,
                    });

                    // ✅ update all rows
                    setRows((prev) =>
                      prev.map((row) =>
                        ids.includes(row.id)
                          ? { ...row, [field]: newValue }
                          : row,
                      ),
                    );

                    // 🔥 CRITICAL FIX: update the currently edited row too
                    api.setEditCellValue({
                      id: rowId,
                      field,
                      value: newValue,
                    });

                    // 🔥 CRITICAL FIX: exit edit mode so UI refreshes
                    api.stopCellEditMode({
                      id: rowId,
                      field,
                    });

                    toast.success("Bulk updated");
                  }

                  // ======================
                  // ✨ SINGLE UPDATE
                  // ======================
                  else {
                    api.setEditCellValue({
                      id: rowId,
                      field,
                      value: newValue,
                    });
                  }
                } catch (err) {
                  console.log(err);
                  toast.error("Update failed");
                }
              }}
              fullWidth
              variant="standard"
            >
              {colOptions.map((opt) => (
                <MenuItem key={opt.label} value={opt.label}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          );
        }

        // 💰 currency input
        if (isCurrencyField) {
          return (
            <TextField
              autoFocus
              variant="standard"
              type="number"
              value={value ?? ""}
              onChange={(e) => {
                api.setEditCellValue({
                  id,
                  field,
                  value: e.target.value === "" ? null : Number(e.target.value),
                });
              }}
              fullWidth
            />
          );
        }

        if (isDateField) {
          return (
            <DatePicker
              autoFocus
              value={value ? dayjs(value) : null}
              onChange={(newValue) => {
                api.setEditCellValue({
                  id,
                  field,
                  value: newValue ? newValue.format("YYYY-MM-DD") : null,
                });
              }}
            />
          );
        }

        return (
          <TextField
            autoFocus
            variant="standard"
            value={value ?? ""}
            onChange={(e) => {
              api.setEditCellValue({
                id,
                field,
                value: e.target.value,
              });
            }}
            fullWidth
          />
        );
      },

      // ✅ INPUT FIELD (NO $)

      // ✅ RENDER CELL
      renderCell: (params) => {
        if (col === "connote_no") {
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                overflow: "hidden",
              }}
            >
              {/* TEXT */}
              <Box
                sx={{
                  flex: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {params.value}
              </Box>

              {/* ICON */}
              <Tooltip title="Open Notes">
                <IconButton
                  size="small"
                  onClick={() => openCommentDrawer(params.row)}
                >
                  <MessageIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          );
        }

        if (isCurrencyField) {
          if (!params.value && params.value !== 0) return "";
          return `$${params.value}`;
        }

        if (isDateField) {
          if (!params.value) return "";
          return dayjs(params.value).format("DD MMM YYYY").toUpperCase();
        }

        // OWNER UI
        if (col === "owner_id") {
          const name =
            col === "owner_name"
              ? params.value
              : params.row.owner_name || "Unknown";

          const initials = name
            ?.split(" ")
            .map((n) => n[0])
            .join("")
            .toUpperCase();

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  backgroundColor: getColorFromName(name),
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                }}
              >
                {initials}
              </div>
              {/* {name} */}
            </div>
          );
        }

        // ✅ SELECT CHIP
        if (isSelectField) {
          const found = colOptions.find((o) => o.label === params.value);

          return (
            <Chip
              label={params.value}
              size="small"
              sx={{
                backgroundColor: found?.color || "#999",
                color: "#fff",
                width: "100%",
                borderRadius: "0px",
                padding: "20px 5px",
              }}
            />
          );
        }

        return params.value;
      },
    };
  });
};
